/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {listEscalationTickets} from '../api'

export const useMutationListEscalationTickets = createReactQueryMutationHook('listEscalationTickets', listEscalationTickets)
